import declare from "dojo/_base/declare";
import PathMatrix from "csi/table/matrix/Path";

const TechnicalCompositionMatrixProcessor = declare(PathMatrix, {
	restrictQuery: true,
});

export = TechnicalCompositionMatrixProcessor;